module.exports = __webpack_public_path__ + "img/18.09044fc.svg";